export default __webpack_public_path__ + "static/depin@2x-304cab07b655ccd38f1529bc0cd8b204.png";